<template>
  <div class="ba-container ba-gp-1 ba-ai-baseline ba-w-100 ba-grid" :id="'page-editor' + _uid">
    <div class='ba-card'>
      <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
        <span class='ba-title'>{{ page.id ? $t('ct-page-edit') : $t('ct-add-new-page') }}</span>
      </div>
      <hr class='ba-hr-row'>
      <div class='ba-content ba-w-100'>

        <form action="/" ref="pageForm" @submit.prevent="savePage()" class="ba-grid ba-gp-1">
          <!-- general settings -->
          <div class="container-accordion-form">
            <div class="card ba-w-100">
              <div class="card-header" id="group-editing" data-toggle="collapse"
                  :data-target="`#collapse-group-editing-general`" aria-expanded="true"
                  :aria-controls="`collapse-group-editing-general`">
                <span class="py-1 d-block ba-text-14 ba-montserrat-600" >{{ $t('ct-general-settings') }}
                  <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                </span>
              </div>
              <div :id="`collapse-group-editing-general`" :aria-labelledby="`group-editing`" class="collapse show"
                data-parent="#accordion">
                <div class="card-body ba-w-100">
                  <div class="ba-flex ba-f-wrap ba-gp-06">

                    <div class="ba-flex ba-w-100 ba-gp-06"
                      :class="page.id && !page.is_member ? 'ba-f-column' : 'ba-f-row'">
                      <div class="ba-flex ba-gp-06" :class="page.id && !page.is_member ? 'ba-w-100' : 'ba-w-50'">
                        <div class="ba-box-input ba-w-100">
                          <label :for="'name' + _uid" class="ba-custom-label">{{ $t('ct-name') }}</label>
                          <input type="text" class="ba-input ba-md" :class="{ 'ba-error': errors.has('page.name') }"
                            v-model="page.name" name="name" :id="'name' + _uid" :placeholder="$t('ct-page-name-plch')"
                            minlength="3" @keydown="errors.clear('page.name')" required />
                          <span v-if="errors.has('page.name')" class="ba-validation-text"
                            v-text="errors.get('page.name')"></span>
                        </div>
                        <div class="ba-grid ba-w-100" v-if="page.id && !page.is_member">
                          <label :for="'initial' + _uid" class="ba-custom-label">{{ $t('ct-initial') }}</label>
                          <select name="initial" :id="'initial' + _uid" class="ba-select ba-md" v-model="page.initial">
                            <option :value="1">{{ $t('ct-yes') }}</option>
                            <option :value="0">{{ $t('ct-no') }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="ba-flex ba-gp-06" :class="page.id && !page.is_member ? 'ba-w-100' : 'ba-w-50'">
                        <div class="ba-box-input ba-w-100">
                          <label :for="'title' + _uid" class="ba-custom-label">{{ $t('ct-title-age') }}</label>
                          <input type="text" class="ba-input ba-md" :class="{ 'ba-error': errors.has('page.title') }"
                            v-model="page.title" name="title" :placeholder="$t('ct-page-title-plch')"
                            :id="'title' + _uid" @keyup="errors.clear('page.title')" required />
                          <span v-if="errors.has('page.title')" class="ba-validation-text"
                            v-text="errors.get('page.title')"></span>
                        </div>
                        <div class="ba-box-input ba-w-100" v-if="page.id">
                          <label :for="'url' + _uid" class="ba-custom-label">{{ $t('ct-address-url') }}</label>
                          <input type="text" class="ba-input ba-md" v-model="page.url" name="url" :id="'url' + _uid"
                            :class="{ 'ba-error': errors.has('page.url') }" @keydown="validateAddress"
                            @keyup="validateAddress" @change="validateAddress" required />
                          <span v-if="errors.has('page.url')" class="ba-validation-text"
                            v-text="errors.get('page.url')"></span>
                        </div>
                      </div>
                    </div>


                    <div class="ba-box-input ba-w-100" v-if="page.configuration">
                      <label :for="'description' + _uid" class="ba-custom-label">{{ $t('ct-description') }}</label>
                      <textarea class="ba-textarea" v-model="page.configuration.description" name="description"
                        :placeholder="$t('ct-page-description-plch')" :id="'description' + _uid" rows="5"></textarea>
                      <span v-if="errors.has('page.configuration.description')" class="ba-validation-text"
                        v-text="errors.get('page.configuration.description')"></span>
                    </div>

                    <div class="ba-flex ba-ai-start ba-gp-06">
                      <div class='ba-grid ba-w-50'>
                        <label :for="'mbossToken' + _uid" class="ba-custom-label">{{ $t('ct-mboss-integration-key')
                          }}</label>
                        <input type="text" class="ba-input ba-md" v-model="page.mboss_token" name="mbossToken"
                          :id="'mbossToken' + _uid" />
                        <small class="ba-color-black18">{{ $t('ct-mboss-integration-key-helper') }}</small>
                      </div>
                      <div class="ba-grid ba-w-50">
                        <label :for="'mbossReference' + _uid" class="ba-custom-label">{{ $t('ct-mboss-reference')
                          }}</label>
                        <input type="text" class="ba-input ba-md" v-model="page.mboss_reference" name="mbossReference"
                          :id="'mbossReference' + _uid" />
                      </div>
                    </div>

                    <div class="ba-grid ba-w-100 ba-gp-06" v-if="page.script">
                      <div class="ba-grid ba-w-100">
                        <label :for="'script-' + Math.random()" class="ba-custom-label">{{ $t('ct-page-script')
                          }}</label>
                        <textarea style="height: 400px !important;" class="ba-textarea ba-w-100"
                          :id="'script-' + Math.random()" :placeholder="$t('ct-page-script-plch')"
                          v-model="page.script.script"></textarea>
                      </div>

                      <div class="ba-w-100 ba-flex ba-ai-center ba-gp-06">
                        <div class='ba-switch ba-sm' @click="changeSyncScript">
                          <input
                            type='checkbox'
                            class='ba-checkbox'
                            :checked="script_sync"
                          >
                          <span class='ba-slider'></span>
                        </div>
                        <span>{{ $t('ct-enable-synchronous-script') }}</span>
                      </div>

                      <alert-box-component type="warning" :with_icon="false">
                        <p slot="content" v-text="$t('ct-sync-script')" />
                      </alert-box-component>

                    </div>
                    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                      <button class='ba-btn ba-md ba-blue' @click.prevent="savePage()">
                        {{ $t('ct-save') }}
                      </button>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container-accordion-form" v-if="!page.id">
            <div class="card ba-w-100">
              <div class="card-header" id="group-editing"  data-toggle="collapse" :data-target="`#collapse-group-editing-template`" aria-expanded="true"
                  :aria-controls="`collapse-group-editing-template`">
                <span class="py-1 d-block ba-text-14 ba-montserrat-600">{{ $t('ct-page-template') }}
                  <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                </span>
              </div>
              <div :id="`collapse-group-editing-template`" :aria-labelledby="`group-editing`" class="collapse show"
                data-parent="#accordion">
                <div class="card-body ba-w-100">
                  <div class="ba-flex ba-f-row ba-ai-start">
                    <div class="ba-flex ba-w-100 ba-gp-1">
                      <div class="ba-form-radio ">
                        <input type="radio" name="modelo" v-model="tipo_modelo" value="blank" :id="'blank' + _uid">
                        <label :for="'blank' + _uid">{{ $t('ct-blank-page') }}</label>
                      </div>
                      <div class="ba-form-radio ">
                        <input type="radio" name="modelo" v-model="tipo_modelo" value="my_pages"
                          :id="'my_pages' + _uid">
                        <label :for="'my_pages' + _uid">{{ $t('ct-my-pages') }}</label>
                      </div>
                      <div class="ba-form-radio ">
                        <input type="radio" name="modelo" v-model="tipo_modelo" value="model_pages"
                          :id="'model_pages' + _uid">
                        <label :for="'model_pages' + _uid">{{ $t('ct-page-templates')
                          }}</label>
                      </div>
                    </div>

                    <div class="ba-grid ba-w-100 ba-gp-1" v-if="tipo_modelo === 'my_pages' || tipo_modelo === 'model_pages'">
                      <select-plus-component
                        :label="$t('ct-select-website-to-copy-page-from')"
                        :items="formatItemsWebsites"
                        @value="website_model = $event.value"
                        :selected="website_model"
                        :invalidFeedback="$t('ct-choose-a-site')"
                        class="background-white"
                        @unlock="changeUnlock"
                        :class="{ 'is-invalid': errors.has('website_model'), 'with-image-preview': tipo_modelo === 'model_pages' }"
                      ></select-plus-component>
                      <select-plus-component
                        v-if="website_model"
                        :label="$t('ct-select-page-as-template')"
                        :items="formatItemsPages"
                        @value="page_model = $event.value"
                        :selected="page_model"
                        :invalidFeedback="$t('ct-choose-a-page')"
                        hasImage="true"
                        :class="{ 'is-invalid': errors.has('page_model') }"
                        class="with-image-preview"
                      ></select-plus-component>
                    </div>
                  </div>
                  <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                    <button class='ba-btn ba-md ba-blue' @click.prevent="savePage()">
                      {{ $t('ct-save') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container-accordion-form">
            <div class="card ba-w-100">
              <div class="card-header" id="group-editing"  data-toggle="collapse" :data-target="`#collapse-group-editing-seo`" aria-expanded="true"
                  :aria-controls="`collapse-group-editing-seo`">
                <span class="py-1 d-block ba-text-14 ba-montserrat-600">{{ $t('ct-seo-settings') }}
                  <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                </span>
              </div>
              <div :id="`collapse-group-editing-seo`" :aria-labelledby="`group-editing`" class="collapse show"
                data-parent="#accordion">
                <div class="card-body ba-w-100" v-if="page.configuration">
                  <div class="ba-flex ba-f-wrap ba-gp-06">

                    <div class="ba-flex ba-w-100 ba-gp-06">
                      <div class="ba-grid ba-w-50">
                        <label :for="'keyword' + _uid" class="ba-custom-label">{{ $t('ct-key-words') }}</label>
                        <textarea class="ba-textarea" v-model="page.configuration.keyword" cols='30' rows='5'
                          :placeholder="$t('ct-key-words-plch')" name="keyword" :id="'keyword' + _uid" />
                      </div>
                      <div class="ba-grid ba-w-50" v-if="page.configuration">
                        <label :for="'metatag' + _uid" class="ba-custom-label">{{ $t('ct-metatag') }}</label>
                        <textarea class="ba-textarea" v-model="page.configuration.metatag" cols='30' rows='5'
                          :placeholder="$t('ct-metatag-plch')" name="metatag" :id="'metatag' + _uid" />
                      </div>
                    </div>


                    <div class="ba-grid ba-w-100">
                      <label :for="'redirect-to' + _uid" class="ba-custom-label">{{ $t('ct-redirect-to') }}</label>
                      <input type="text" class="ba-input ba-md" v-model="page.configuration.redirect_to" name="redirect-to"
                        :id="'redirect-to' + _uid" />
                      <small class="ba-color-black18">{{ $t('ct-redirect-to-helper') }}</small>
                    </div>

                    <div class="ba-grid ba-w-100 ba-gp-02">
                      <div class="ba-flex ba-ai-center ba-gp-06">
                        <div class='ba-switch ba-sm' @click="page.configuration.no_index = !page.configuration.no_index">
                          <input type='checkbox' class='ba-checkbox' v-model="page.configuration.no_index">
                          <span class='ba-slider'></span>
                        </div>
                        <span>{{ $t('ct-no-index') }}</span>
                      </div>

                      <small class="ba-w-100 ba-color-black18">{{ $t('ct-no-index-helper') }}</small>
                    </div>

                    <div class="ba-grid ba-w-50">
                      <div class="shere-image-container">
                        <label class="ba-custom-label">{{ $t('ct-page-share-img') }}</label>

                        <div class="shere-image-preview">
                          <div class="share-image" :style="`background-image: url('${page.configuration.og_image}');`"
                            v-if="page.configuration.og_image" />
                          <div class="ba-w-100" v-else>
                            <div class="shere-empty" @click.prevent="uploadImagePage(page)">
                              <builderall-icon code='9da0'></builderall-icon>
                              <!-- <button class="btn btn-primary btn-choose"
                              @click.prevent="uploadImagePage(page)"><font-awesome-icon :icon="['fas', 'plus-circle']"
                                class="font-awesome-icon mr-2" />{{ $t('ct-choose') }}
                            </button> -->
                            </div>
                            <small class="ba-color-black18">{{ $t('ct-share-img-info') }}</small>
                          </div>
                        </div>

                        <div class="ba-w-100 ba-mg-y-1" v-if="page.configuration.og_image">
                          <div class="ba-flex ba-ai-center ba-jc-center ba-gp-06">
                            <button class='ba-btn ba-btn-normal ba-sm ba-rounded'
                              @click.prevent="uploadImagePage(page)">
                              <builderall-icon code='edit' />
                            </button>
                            <button class='ba-btn ba-btn-trash ba-sm ba-rounded' v-show="page.configuration.og_image"
                              v-on:click.prevent="removeImage">
                              <builderall-icon code='trash' />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                    <button class='ba-btn ba-md ba-blue' @click.prevent="savePage()">
                      {{ $t('ct-save') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <template v-if="page.id">
            <!-- popup settings -->
            <div class="ba-grid ba-gp-1">
              <div class="container-accordion-form">
                <div class="card ba-w-100">
                  <div class="card-header" id="group-editing-popup" data-toggle="collapse"
                      :data-target="`#collapse-group-editing-popup`" aria-expanded="true"
                      :aria-controls="`collapse-group-editing-popup`">
                    <span class="py-1 d-block ba-text-14 ba-montserrat-600" >{{ $t('ct-popup-settings') }}
                      <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                    </span>
                  </div>
                  <div :id="`collapse-group-editing-popup`" :aria-labelledby="`group-editing-popup`"
                    class="collapse show" data-parent="#group-editing-popup">
                    <div class="card-body ba-w-100 ba-grid ba-gp-08">
                      <div class="ba-flex ba-w-100 ba-gp-08 ba-ai-start">

                        <div class="ba-w-50 ba-grid ba-gp-08">
                          <div class="ba-grid ba-gp-1">
                            <span class="ba-montserrat-500 ba-text-14">{{ $t('ct-desktop') }}</span>
                            <div class="ba-grid">
                              <label for="popup_desktop" class="ba-custom-label">{{ $t('ct-which-popup') }}</label>
                              <select class="ba-select ba-md" id="popup_desktop"
                                v-model="popupsSettings.desktop.popup_id">
                                <option v-for="(popup) in popups" :value="popup.id">{{ popup.name }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="ba-grid" v-if="popupsSettings.desktop.popup_id != 0">
                            <label for="popup_type_desktop" class="ba-custom-label">{{ $t('ct-type-of-popup') }}</label>
                            <select class="ba-select ba-md" id="popup_type_desktop"
                              v-model="popupsSettings.desktop.type">
                              <option value="time">{{ $t('ct-time-popup') }}</option>
                              <option value="exit">{{ $t('ct-exit-popup') }}</option>
                              <option value="scroll">{{ $t('ct-scroll-popup') }}</option>
                            </select>
                          </div>
                          <template v-if="popupsSettings.desktop.popup_id !== 0">
                            <div class="ba-flex ba-w-100 ba-gp-08">
                              <div class="ba-grid ba-w-50">
                                <label for="popup_desktop_size" class="ba-custom-label">{{ $t('ct-size-popup')
                                  }}</label>
                                <select class="ba-select ba-md" id="popup_desktop_size"
                                  v-model="popupsSettings.desktop.size">
                                  <option value="auto">{{ $t('ct-size-auto') }}</option>
                                  <option value="full-size">{{ $t('ct-size-full-size') }}</option>
                                </select>
                              </div>

                              <div class="ba-grid ba-w-50">
                                <label for="popup_desktop_overlay" class="ba-custom-label">{{ $t('ct-overlay-popup')
                                  }}</label>
                                <select class="ba-select ba-md" id="popup_desktop_overlay"
                                  v-model="popupsSettings.desktop.overlay">
                                  <option value="1">{{ $t('ct-popup-overlay-true') }}</option>
                                  <option value="0">{{ $t('ct-popup-overlay-false') }}</option>
                                </select>
                              </div>
                            </div>

                            <div class="ba-flex ba-w-100 ba-gp-08" v-if="popupsSettings.desktop.size === 'full-size'">
                              <div class="ba-grid ba-w-50">
                                <label class="ba-custom-label">{{ $t('ct-direction-popup') }}</label>
                                <select class="ba-select ba-md" v-model="popupsSettings.desktop.direction">
                                  <option value="center">{{ $t('ct-popup-direction-center') }}</option>
                                  <option value="bottom">{{ $t('ct-popup-direction-bottom') }}</option>
                                  <option value="top">{{ $t('ct-popup-direction-top') }}</option>
                                </select>
                              </div>
                              <div v-if="popupsSettings.desktop.direction !== 'center'" class="ba-w-50 ba-grid">
                                <label for="" class="ba-custom-label">{{ $t('ct-popup-maxheight') }}</label>
                                <div class="ba-flex ba-gp-02">
                                  <input type="range" class="custom-range w-75" step="1" min="20" max="100"
                                    v-model="popupsSettings.desktop.maxHeight">
                                  <span class="ba-montserrat-600 ba-text-14">{{ popupsSettings.desktop.maxHeight }}%</span>
                                </div>
                              </div>
                            </div>
                          </template>
                          <!-- <div v-show="popupsSettings.desktop.popup_id != 0"> -->

                          <div>

                            <div class="ba-flex ba-w-100 ba-gp-08" v-show="this.popupsSettings.desktop.type === 'time'">
                              <div class="ba-grid ba-w-50">
                                <label for="popup_desktop_time_min" class="ba-custom-label">{{ $t('ct-time-popup-min')
                                  }}</label>
                                <input type="number" id="popup_desktop_time_min" class="ba-input ba-md" min="0" max="60"
                                  v-model="popupsSettings.desktop.min">
                              </div>
                              <div class="ba-grid ba-w-50">
                                <label for="popup_desktop_time_sec" class="ba-custom-label">{{ $t('ct-time-popup-sec')
                                  }}</label>
                                <input type="number" id="popup_desktop_time_sec" class="ba-input ba-md" min="0" max="60"
                                  v-model="popupsSettings.desktop.sec">
                              </div>
                            </div>

                            <div class="ba-w-100 ba-grid" v-show="this.popupsSettings.desktop.type === 'scroll'">
                              <label for="" class="ba-custom-label">{{ $t('ct-scroll-popup-value') }}</label>
                              <div class="ba-flex ba-w-100 ba-gp-02">
                                <input type="range" class="custom-range" style="width: 90%" step="1" min="0" max="100"
                                  v-model="popupsSettings.desktop.scroll">
                                <span class="ba-montserrat-600 ba-text-14">{{ popupsSettings.desktop.scroll }}%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ba-w-50 ba-grid ba-gp-08">
                          <div class="ba-grid ba-gp-1">
                            <span class="ba-montserrat-500 ba-text-14">{{ $t('ct-mobile') }}</span>
                            <div class="ba-grid">
                              <label for="popup_mobile" class="ba-custom-label">{{ $t('ct-which-popup') }}</label>
                              <select class="ba-select ba-md" id="popup_mobile" v-model="popupsSettings.mobile.popup_id">
                                <option v-for="(popup) in popups" :value="popup.id">{{ popup.name }}</option>
                              </select>
                            </div>
                          </div>

                          <template v-if="popupsSettings.mobile.popup_id != 0">
                            <div class="ba-grid">
                              <label for="popup_type_mobile" class="ba-custom-label">{{ $t('ct-type-of-popup')
                                }}</label>
                              <select class="ba-select ba-md" id="popup_type_mobile"
                                v-model="popupsSettings.mobile.type">
                                <option value="time">{{ $t('ct-time-popup') }}</option>
                                <option value="scroll">{{ $t('ct-scroll-popup') }}</option>
                              </select>
                            </div>

                            <div class="ba-flex ba-w-50 ba-gp-08" v-show="this.popupsSettings.mobile.type === 'time'">
                              <div class="ba-grid ba-w-50">
                                <label for="popup_mobile_time_min" class="ba-custom-label">{{ $t('ct-time-popup-min')
                                  }}</label>
                                <input type="number" id="popup_mobile_time_min" class="ba-input ba-md" min="0" max="60"
                                  v-model="popupsSettings.mobile.min">
                              </div>
                              <div class="ba-grid ba-w-50">
                                <label for="popup_mobile_time_sec" class="ba-custom-label">{{ $t('ct-time-popup-sec')
                                  }}</label>
                                <input type="number" id="popup_mobile_time_sec" class="ba-input ba-md" min="0" max="60"
                                  v-model="popupsSettings.mobile.sec">
                              </div>
                            </div>

                            <div class="ba-w-100 ba-grid" v-show="this.popupsSettings.mobile.type === 'scroll'">
                              <label for="" class="ba-custom-label">{{ $t('ct-scroll-popup-value') }}</label>
                              <div class="ba-flex ba-w-100 ba-gp-02">
                                <input type="range" class="custom-range" style="width: 90%" step="1" min="0" max="100"
                                  v-model="popupsSettings.mobile.scroll">
                                <span class="ba-montserrat-600 ba-text-14">{{ popupsSettings.mobile.scroll }}%</span>
                              </div>
                            </div>
                          </template>

                        </div>
                      </div>
                      <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                        <button class='ba-btn ba-md ba-blue' @click.prevent="savePage()">
                          {{ $t('ct-save') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-accordion-form">
                <div class="card ba-w-100">
                  <div class="card-header" id="group-editing-header"  data-toggle="collapse" :data-target="`#collapse-group-editing-header`" aria-expanded="true"
                      :aria-controls="`collapse-group-editing-header`">
                    <span class="py-1 d-block ba-text-14 ba-montserrat-600">{{ $t('ct-header-settings') }}
                      <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                    </span>
                  </div>
                  <div :id="`collapse-group-editing-header`" :aria-labelledby="`group-editing-header`"
                    class="collapse show" data-parent="#group-editing-header">
                    <div class="card-body ba-w-100">
                      <div class="ba-grid ba-w-100 ba-gp-08">
                        <div class="ba-flex ba-w-100 ba-gp-08 ba-ai-start">
                          <div class="ba-grid ba-w-50 ba-gp-08">

                            <div class="ba-grid ba-gp-1">
                              <span class="ba-montserrat-500 ba-text-14">{{ $t('ct-desktop') }}</span>
                              <div class="ba-grid">
                                <label for="header_desktop" class="ba-custom-label">{{ $t('ct-which-header') }}</label>
                                <select class="ba-select ba-md" id="header_desktop"
                                  v-model="headerSettings.desktop.header_id">
                                  <option v-for="(header) in headers" :value="header.id">{{ header.name }}</option>
                                </select>
                              </div>
                            </div>


                            <div class="ba-flex ba-ai-center ba-gp-02">
                              <div class="ba-switch ba-sm" @click="headerSettings.desktop.modify_on_scroll = !headerSettings.desktop.modify_on_scroll">
                                <input type="checkbox" class="ba-checkbox"
                                  :checked="headerSettings.desktop.modify_on_scroll" id="desktop-modify-on-scroll" />
                                <span class="ba-slider"></span>
                              </div>
                              <span for="desktop-modify-on-scroll" v-text="$t('ct-modify-on-scroll')"
                                class="ba-text-12 ba-montserrat-500" />
                            </div>

                            <div class="ba-grid" v-if="headerSettings.desktop.modify_on_scroll">
                              <label for="header_header_desktop" class="ba-custom-label">{{
                                $t('ct-which-secondary-header') }}</label>
                              <select class="ba-select ba-md" id="header_header_desktop"
                                v-model="headerSettings.desktop.secondary_header_id">
                                <option
                                  v-for="(header) in headers.filter(header => header.id !== headerSettings.desktop.header_id)"
                                  :value="header.id">{{ header.name }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="ba-grid ba-w-50 ba-gp-08">
                            <div class="ba-grid ba-gp-1">

                              <span class="ba-montserrat-500 ba-text-14">{{ $t('ct-mobile') }}</span>
                              <div class="ba-grid">
                                <label for="header_mobile" class="ba-custom-label">{{ $t('ct-which-header') }}</label>
                                <select class="ba-select ba-md" id="header_mobile"
                                  v-model="headerSettings.mobile.header_id">
                                  <option v-for="(header) in headers" :value="header.id">{{ header.name }}</option>
                                </select>
                              </div>
                            </div>

                            <div class="ba-flex ba-ai-center ba-gp-02">
                              <div class="ba-switch ba-sm" @click="headerSettings.mobile.modify_on_scroll = !headerSettings.mobile.modify_on_scroll">
                                <input type="checkbox" class="ba-checkbox"
                                  :checked="headerSettings.mobile.modify_on_scroll" id="mobile-modify-on-scroll" />
                                <span class="ba-slider"></span>
                              </div>
                              <span for="mobile-modify-on-scroll" v-text="$t('ct-modify-on-scroll')"
                                class="ba-text-12 ba-montserrat-500" />
                            </div>

                            <div class="ba-grid" v-if="headerSettings.mobile.modify_on_scroll">
                              <label for="mobile-header-secondary-id" class="ba-custom-label">{{
                                $t('ct-which-secondary-header')
                              }}</label>
                              <select class="ba-select ba-md" id="mobile-header-secondary-id"
                                v-model="headerSettings.mobile.secondary_header_id">
                                <option
                                  v-for="(header) in headers.filter(header => header.id !== headerSettings.mobile.header_id)"
                                  :value="header.id">{{ header.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                          <button class='ba-btn ba-md ba-blue' @click.prevent="savePage()">
                            {{ $t('ct-save') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-accordion-form">
                <div class="card ba-w-100">
                  <div class="card-header" id="group-editing-footer"  data-toggle="collapse" :data-target="`#collapse-group-editing-footer`" aria-expanded="true"
                      :aria-controls="`collapse-group-editing-footer`">
                    <span class="py-1 d-block ba-text-14 ba-montserrat-600">{{ $t('ct-footer-settings') }}
                      <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                    </span>
                  </div>
                  <div :id="`collapse-group-editing-footer`" :aria-labelledby="`group-editing-footer`"
                    class="collapse show" data-parent="#group-editing-footer">
                    <div class="card-body ba-w-100 ba-grid ba-gp-08">
                      <div class="ba-flex ba-gp-08">
                        <div class="ba-grid ba-w-50 ba-gp-1">
                          <span class="ba-montserrat-500 ba-text-14">{{ $t('ct-desktop') }}</span>
                          <div class="ba-grid">
                            <label for="footer_desktop" class="ba-custom-label">{{ $t('ct-which-footer') }}</label>
                            <select class="ba-select ba-md" id="footer_desktop"
                              v-model="footerSettings.desktop.footer_id">
                              <option v-for="(footer) in footers" :value="footer.id">{{ footer.name }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="ba-grid ba-w-50 ba-gp-1">
                          <span class="ba-montserrat-500 ba-text-14">{{ $t('ct-mobile') }}</span>
                          <div class="ba-grid">
                            <label for="footer_mobile" class="ba-custom-label">{{ $t('ct-which-footer') }}</label>
                            <select class="ba-select ba-md" id="footer_mobile"
                              v-model="footerSettings.mobile.footer_id">
                              <option v-for="(footer) in footers" :value="footer.id">{{ footer.name }}</option>
                            </select>
                          </div>

                        </div>
                      </div>
                      <div class="ba-w-100 ba-flex ba-ai-center ba-jc-fe">
                        <button class='ba-btn ba-md ba-blue' @click.prevent="savePage()">
                          {{ $t('ct-save') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </form>
      </div>
    </div>
  </div>
</template>
<script>

import AlertBoxComponent from '../../commons/AlertBoxComponent';
import SelectPlusComponent from '../components/SelectPlus';
import Errors from '../../../js/base/Errors';
import {
  get as getPage,
  create as createPage,
  edit as editPage,
  getPagesFromWebsite
} from '../../../js/services/editor/page';
import { getAll as getTemplates } from '../../../js/services/editor/template';

import { getWebsiteLink } from '../../../js/services/editor/link';

import {
  getPageConfig,
  setPageConfig
} from '../../../js/services/editor/configManager';
import {
  getAllUserWebsites
} from '../../../js/services/editor/website';
import axios from "axios";

const cursorFocus = function (elem) {
  var x = window.scrollX, y = window.scrollY;
  elem.focus();
  window.scrollTo(x, y);
};

function initialState() {
  return {
    id: Math.random(),
    action: false,
    errors: new Errors(),
    tipo_modelo: 'blank',
    url_importer: '',
    search_pages: '',
    websites_model: [],
    website_model: null,
    pages_model: [],
    page_model: null,
    script_sync: false,
    imagePage: {
      show: false,
      page: ''
    },
    page: {
      name: '',
      title: '',
      layout_id: '',
      initial: 0,
      configuration: {
        page_id: '',
        description: '',
        keyword: '',
        metatag: '',
        redirect_to: '',
        no_index: false,
        og_image: ''
      },
      script: {
        script: '',
        script_sync: 0
      }
    },
    headers: [],
    headerSettings: {
      desktop: {
        header_id: 0,
        secondary_header_id: 0,
        modify_on_scroll: false,
      },
      mobile: {
        header_id: 0,
        secondary_header_id: 0,
        modify_on_scroll: false,
      }
    },
    footers: [],
    footerSettings: {
      desktop: {
        footer_id: 0
      },
      mobile: {
        footer_id: 0
      }
    },
    popups: [],
    popupsSettings: {
      desktop: {
        popup_id: 0,
        type: 'time', // time, exit, scroll
        min: 0,
        sec: 0,
        scroll: 0,
        size: 'auto', // auto full-size
        maxHeight: 100,
        direction: 'center', // bottom
        overlay: 1 // 1 or 0
      },
      mobile: {
        popup_id: 0,
        type: 'time', // time, exit, scroll
        min: 0,
        sec: 30,
        scroll: 0
      }
    },
    configuration: {
      page_id: '',
      description: '',
      keyword: '',
      og_image: '',
      metatag: '',
      redirect_to: '',
      no_index: false
    },
    script: {
      script: ''
    },
    menuNavBar: [
      {
        text: 'Meus Sites',
        link: 'Home',
        router: true,
        active: false,
        target: false,
        current: false
      }
    ]
  };
}
export default {
  name: 'Page',
  components: { SelectPlusComponent, AlertBoxComponent },
  props: ['newPage'],
  data: function () {
    return initialState();
  },
  computed: {
    formatItemsWebsites() {
      let vm = this;
      var items = [];
      this.websites_model.forEach(function (item, index) {
        var obj = {
          'label': vm.$t(item.title),
          'title': item.title,
          'value': item.encrypted_id,
          'is_premium': item.is_premium,
          'has_premium_template_access': item.has_premium_template_access,
          'preview_url': vm.tipo_modelo == 'my_pages' ? item.access_url : 'https://' + item.title + vm.domain
        };

        if (item.thumbnail != null) {
          obj.img = item.thumbnail_portrait;
        }

        items.push(obj);
      });

      items.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });

      return items;
    },
    formatItemsPages() {
      var items = [];
      var vm = this;

      this.pages_model.forEach(function (item, index) {
        var img = '/static/images/cheetah-og.png';
        if (item.configuration != null && item.configuration.og_image != null) {
          img = item.configuration.og_image;
        }

        items.push({
          'img': img,
          'label': item.title,
          'url': (vm.tipo_modelo === 'my_pages') ? item.url : '',
          'value': item.encrypted_id
        });
      });

      items.sort((a, b) => {
        return a.label.localeCompare(b.label);
      });

      return items;
    },

    filteredItems() {
      if (this.search_pages !== '') {
        return this.formatItemsPages.filter(item => {
          return item.label.toLowerCase().indexOf(this.search_pages.toLowerCase()) > -1;
        });
      }
      return this.formatItemsPages;
    },

    domain() {
      return typeof process.env.TEMPLATE_DOMAIN !== 'undefined' ? process.env.TEMPLATE_DOMAIN : '.template.builderall.com';
    },
  },
  methods: {
    changeUnlock(title){
      this.websites_model.find(x => x.title == title).has_premium_template_access = true;
      this.$snotify.success(this.$t('ct-premium-template-unlocked'));
    },
    changeSyncScript(){
      this.script_sync = !this.script_sync;

      this.page.script.script_sync = this.script_sync ? 1 : 0;
    },

    reset: function () {
      Object.assign(this.$data, initialState());
    },

    focus() {
      var vm = this;
      setTimeout(function () {
        $(vm.$refs.pesquisa).focus();
      }, 250);
    },

    buttonSave(disabled = true) {
      let buttons = document.querySelectorAll('[button-action="save"]');

      for (var i = 0, len = buttons.length; i < len; i++) {
        if (disabled) {
          buttons[i].disabled = true;
        } else {
          buttons[i].disabled = false;
        }
      }
    },

    new(encrypted_layout_id) {
      this.reset();
      this.page.encrypted_layout_id = encrypted_layout_id; // website.layouts[0].encrypted_id

      this.$Progress.finish();
    },

    async edit(page_id) {
      this.reset();
      this.$loading.show();
      let translationPopupEmpty = this.$t('ct-popup-empty');
      let translationHeaderEmpty = this.$t('ct-header-empty');
      let translationFooterEmpty = this.$t('ct-footer-empty');

      await getPage(page_id)
        .then(async data => {
          this.setValue(data.data);
          this.website = this.page.layout.website;

          this.popups.push({ id: 0, name: translationPopupEmpty });
          this.headers.push({ id: 0, name: translationHeaderEmpty });
          this.footers.push({ id: 0, name: translationFooterEmpty });

          await getWebsiteLink(this.page.layout.website.encrypted_id).then(async (links) => {
            links.data.layouts[0].popups.forEach((popup) => {
              this.popups.push({ id: popup.id, name: popup.name });
            });

            links.data.layouts[0].headers.forEach((header) => {
              this.headers.push({ id: header.id, name: header.name });
            });

            links.data.layouts[0].footers.forEach((footer) => {
              this.footers.push({ id: footer.id, name: footer.name });
            });

            await getPageConfig(this.page.encrypted_id)
              .then((data) => {
                if (typeof data.data !== 'undefined' && typeof data.data.popupSettings !== 'undefined' && data.data.popupSettings != null) {
                  let popupsSettings = JSON.parse(data.data.popupSettings.value);
                  popupsSettings.desktop = { ...this.popupsSettings.desktop, ...popupsSettings.desktop };
                  popupsSettings.mobile = { ...this.popupsSettings.mobile, ...popupsSettings.mobile };
                  this.popupsSettings = popupsSettings;
                }

                if (typeof data.data !== 'undefined' && typeof data.data.headerSettings !== 'undefined' && data.data.headerSettings != null) {
                  let headerSettings = JSON.parse(data.data.headerSettings.value);
                  headerSettings.desktop = { ...this.headerSettings.desktop, ...headerSettings.desktop };
                  headerSettings.mobile = { ...this.headerSettings.mobile, ...headerSettings.mobile };
                  this.headerSettings = headerSettings;
                }

                if (typeof data.data !== 'undefined' && typeof data.data.footerSettings !== 'undefined' && data.data.footerSettings != null) {
                  this.footerSettings = JSON.parse(data.data.footerSettings.value);
                }

                if (this.action) {
                  $('html, body').animate({
                    scrollTop: $('.collapse.show').offset().top
                  }, 1000);
                }
              });
          });
        })
        .catch((response) => {
          this.$snotify.error(this.$t('ct-error-creating-page'));
          console.warn('error', response.response);
          this.errors.record({ page: response.response.data.errors });
        })
        .finally(() => {
          this.$loading.hide();
          window.vm.$Progress.finish();
        });
    },

    validateAddress() {
      if (this.page.url && !this.page.url.match(/^[a-zA-Z0-9_-]*$/)) {
        this.errors.add('url', 'invalid-url-page-regex', 'page');
      }
      if (this.page.url.match(/^[a-zA-Z0-9_-]*$/)) {
        this.page.url = this.page.url.match(/^[a-zA-Z0-9_-]*$/).input;
        if (this.errors.any()) this.errors.clear('page.url');
      }
      if (/^\w*website\b$/i.test(this.page.url)) {
        this.errors.add('url', 'invalid-url-page-name', 'page');
      }
    },

    validate() {
      if (!this.page.title && !(this.page.title.length > 0)) {
        this.errors.add('title', 'validation-required', 'page');
      }

      if (!this.page.name && !(this.page.name.length > 0)) {
        this.errors.add('name', 'validation-required', 'page');
      }

      if (this.page.id == null && /^\w*website\b$/i.test(this.page.name)) {
        this.errors.add('name', 'invalid-page-name', 'page');
      }


      if (this.page.id == null && this.tipo_modelo !== 'blank' && this.page_model == null) {
        this.errors.add('website_model', 'validation-required');
        this.errors.add('page_model', 'validation-required');
      }
      console.log(this.errors.errors);
      return this.errors.any();
    },

    changeScript(value) {
      this.page.script.script = value;
    },

    uploadImagePage(page) {
      this.imagePage.show = true;
      this.imagePage.page = page;

      let values = {
        action: 'open',
        type: 'Images',
        save: this.saveImagePage,
        close: this.closeUploadPage
      };

      this.$root.$emit('fileMananger', values);
    },

    removeImage() {
      this.page.configuration.og_image = '';
    },

    saveImagePage(image) {
      this.page.configuration.og_image = image;

      this.closeUploadPage();
    },

    closeUploadPage() {
      let values = {
        action: "close",
        type: "Images",
        save: this.saveImagePage,
        close: this.closeUploadPage,
      };

      this.$root.$emit("fileMananger", values);

      this.imagePage = {
        show: false,
        page: ''
      };
    },

    setValue(data) {
      this.page = data;
      if (this.page.configuration === null) { this.page.configuration = this.configuration }
      if (this.page.script === null || typeof this.page.script === 'undefined') this.page.script = this.script;
      if (typeof this.page.script.script === 'undefined') this.page.script = this.script;
    },

    async create() {
      let vm = this;

      // Caso usou um modelo
      if (vm.tipo_modelo !== 'blank') {
        vm.page.page_model = vm.page_model;
      }

      this.$loading.show();
      this.buttonSave();

      await createPage(this.page)
        .then(({ data }) => {
          this.$snotify.success(this.$t('ct-success-true'));

          this.$store.commit('website', false);
          this.$router.push({
            name: 'SitePages',
            params: { id: data.layout.website.encrypted_id }
          });
        })
        .catch(async response => {
          console.warn('error', response);
          if (response.response.data.errors) {
            await this.errors.record({ page: response.response.data.errors });
            cursorFocus(document.querySelector('.is-invalid'));
          }
        })
        .finally(() => {
          this.buttonSave(false);
          setTimeout(() => {
            this.$loading.hide();
          }, 500);
        });
    },

    save() {
      let website_encrypted_id = this.page.layout.website.encrypted_id;
      this.popupsSettings.desktop.scroll = parseInt(this.popupsSettings.desktop.scroll);
      this.popupsSettings.mobile.scroll = parseInt(this.popupsSettings.mobile.scroll);

      if (!this.validate()) {
        this.$loading.show();
        this.buttonSave();

        let vm = this;
        editPage(this.page)
          .then(data => {
            var page = this.page;
            this.$snotify.success(this.$t('ct-edit-page'));
            this.setValue(data.data);

            this.saveConfigs();
          })
          .catch(async error => {
            if (error.response) {
              await this.errors.record({ page: error.response.data.errors });
              cursorFocus(document.querySelector('.is-invalid'));
            }

            this.$snotify.error(this.$t('ct-error-editing-page'));
          })
          .finally(() => {
            this.buttonSave(false);
            setTimeout(() => {
              this.$loading.hide();
            }, 500);
          });
      }
    },

    savePage() {

      if (!this.validate()) {
        if (this.page.id !== undefined) {
          this.save();
        } else {
          this.create();
        }
      } else {
        let vm = this;

        setTimeout(function () {
          vm.$snotify.error(vm.$t('ct-please-check-the-required-fields'));
          const target = $('#page-editor' + vm._uid + ' .is-invalid').get(0);
          if (target) {
            target.scrollIntoView();
          }
          var y = $('#page-editor' + vm._uid + ' .sweet-modal').scrollTop() - 60;
          $('#page-editor' + vm._uid + ' .sweet-modal').scrollTop(y);
        }, 200);
      }
    },

    async saveConfigs() {
      let website_encrypted_id = this.page.layout.website.encrypted_id;

      await setPageConfig({
        page_id: this.page.encrypted_id,
        key: 'popupSettings',
        value: JSON.stringify(this.popupsSettings)
      }).then((data) => {
        console.log('popup finish');
      });

      await setPageConfig({
        page_id: this.page.encrypted_id,
        key: 'headerSettings',
        value: JSON.stringify(this.headerSettings)
      }).then((data) => {
        console.log('header finish');
      });

      await setPageConfig({
        page_id: this.page.encrypted_id,
        key: 'footerSettings',
        value: JSON.stringify(this.footerSettings)
      }).then((data) => {
        console.log('footer finish');
      });

      this.$store.commit('website', false);

      this.$router.push({
        name: 'SitePages',
        params: { id: website_encrypted_id }
      });
    },

    fetchData() {
      let pageId = this.$route.params.page_id;
      let layoutId = this.$route.params.layout_id;

      if (pageId) {
        this.edit(pageId);
      } else if (layoutId) {
        this.new(layoutId);
      }
    }
  },
  watch: {
    'tipo_modelo': function () {
      this.websites_model = [];
      this.page.page_model = null;
      this.website_model = null;
      let vm = this;
      if (this.tipo_modelo == 'blank') {
        vm.$loading.hide();
      }
      if (this.tipo_modelo == 'my_pages') {
        vm.$loading.show();
        getAllUserWebsites().then(res => {
          vm.$loading.hide();
          vm.websites_model = res.data;
        }).catch(err => {
          vm.$loading.hide();
          console.error('Error getting all websites', err);
        });
      } else if (this.tipo_modelo == 'model_pages') {
        vm.$loading.show();
        getTemplates().then(res => {
          vm.websites_model = res.data.templates;
          vm.$loading.hide();
        }).catch(err => {
          vm.$loading.hide();
          console.error('Error getting all templates', err);
        });
      }
    },
    'page.script.script_sync': function (val) {
      this.script_sync = val == 1;
    },
    'website_model': function (val) {
      this.page.page_model = null;
      let vm = this;

      if (val) {
        vm.$loading.show();
        getPagesFromWebsite(val).then(res => {
          vm.$loading.hide();
          vm.pages_model = res.data.data;
        }).catch(err => {
          vm.$loading.hide();
          console.error('Error getting all websites page', err);
        });
      }
    },
    'popupsSettings.desktop.min': function (val) {
      if (isNaN(val) || val < 0) {
        this.popupsSettings.desktop.min = 0;
      } else {
        this.popupsSettings.desktop.min = parseInt(val);
      }
    },
    'popupsSettings.desktop.sec': function (val) {
      if (isNaN(val) || val < 0) {
        this.popupsSettings.desktop.sec = 0;
      } else {
        this.popupsSettings.desktop.sec = parseInt(val);
      }
    },
    'popupsSettings.mobile.min': function (val) {
      if (isNaN(val) || val < 0) {
        this.popupsSettings.mobile.min = 0;
      } else {
        this.popupsSettings.mobile.min = parseInt(val);
      }
    },
    'popupsSettings.mobile.sec': function (val) {
      if (isNaN(val) || val < 0) {
        this.popupsSettings.mobile.sec = 0;
      } else {
        this.popupsSettings.mobile.sec = parseInt(val);
      }
    },

    '$route': function (current, old) {
      try {
        this.fetchData();
      } catch (e) {
        console.error(e);
      }
    }
  },

  created() {
    this.fetchData();
  }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Page.vue